module.exports = __webpack_public_path__ + "static/media/tela6.4d570aff.png";